import React from 'react';
import Badge from '../../base/badge';
import BaseLabelText from '../../base/label-text';
import usePayoutStore from '../../../store/payout';
import { useBeneficiaryStore } from '../../../store';
import { getBeneficiaryProperty } from '../../../utils/beneficiary.util';
interface DocumentDetailsProps {
  label: string;
  type: 'success' | 'pending';
}
const DocumentDetails: React.FC<DocumentDetailsProps> = ({ label, type }) => {
  return (
    <div className="flex gap-1 items-center">
      <p className="text-[#111827] text-sm leading-5 tracking-[0.2px] font-normal">
        {label}
      </p>
      <Badge type={type} label={type === 'success' ? 'Submitted' : 'Pending'} />
    </div>
  );
};
interface ReviewPayoutProps {
  onNegotiateRate: () => void;
}

const ReviewPayout: React.FC<ReviewPayoutProps> = ({ onNegotiateRate }) => {
  const { payoutPayload, payoutSummary, payoutCollectionAccount } =
    usePayoutStore();
  const { beneficiaryPayload } = useBeneficiaryStore();

  return (
    <div className="flex flex-col gap-6">
      <div>
        <p className="text-gray-text text-sm">
          Please review all the information before submitting your payout
          request
        </p>
      </div>
      <div className="flex flex-col p-6 gap-2 rounded-[24px] border border-[#F1F2F4]">
        <p className="font-semibold text-lg mb-4">Exchange Details</p>
        <div className="flex gap-[28px]">
          <BaseLabelText
            label="From Currency"
            value={payoutPayload.fromCurrencyCode}
            type="vertical-reverse"
            allowCopy
          />
          <BaseLabelText
            label="To Currency"
            value={payoutPayload.toCurrencyCode}
            type="vertical-reverse"
            allowCopy
          />
          <BaseLabelText
            label="Exchange Rate"
            value={payoutSummary.exchangeRateText}
            type="vertical-reverse"
            allowCopy
          />
          <BaseLabelText
            label="To be Sent"
            value={payoutSummary.sendingAmountText}
            type="vertical-reverse"
            allowCopy
          />
          <BaseLabelText
            label="To be Received"
            value={payoutSummary.receivingAmountText}
            type="vertical-reverse"
            allowCopy
          />
        </div>
      </div>

      <div className="flex flex-col p-6 gap-2 rounded-[24px] border border-[#F1F2F4]">
        <p className="font-semibold text-lg mb-4">Beneficiary Details</p>
        <div className="flex gap-[28px]">
          <BaseLabelText
            label="Name"
            value={beneficiaryPayload.accountHolderName ?? '-'}
            type="vertical-reverse"
            allowCopy
          />
          <BaseLabelText
            label="Email Address"
            value={beneficiaryPayload.beneficiaryEmail ?? '-'}
            type="vertical-reverse"
            allowCopy
          />
          <BaseLabelText
            label="Bank Name"
            value={beneficiaryPayload.bankName ?? '-'}
            type="vertical-reverse"
            allowCopy
          />
          <BaseLabelText
            label="Account Number"
            value={getBeneficiaryProperty(beneficiaryPayload) ?? '-'}
            type="vertical-reverse"
            allowCopy
          />
        </div>
      </div>

      <div className="flex flex-col p-6 gap-2 rounded-[24px] border border-[#F1F2F4]">
        <p className="font-semibold text-lg mb-4">Collection Account Details</p>
        <div className="flex gap-[28px]">
          <BaseLabelText
            label="Bank Name"
            value={payoutCollectionAccount.bankName}
            type="vertical-reverse"
            allowCopy
          />
          <BaseLabelText
            label="Account Number"
            value={payoutCollectionAccount.accountNumber}
            type="vertical-reverse"
            allowCopy
          />
          <BaseLabelText
            label="Account Name"
            value={payoutCollectionAccount.accountName}
            type="vertical-reverse"
            allowCopy
          />
          <BaseLabelText
            label="Currency"
            value={payoutCollectionAccount.currencyCode}
            type="vertical-reverse"
            allowCopy
          />
        </div>
      </div>

      <div className="flex flex-col p-6 gap-2 rounded-[24px] border border-[#F1F2F4]">
        <p className="font-semibold text-lg mb-4">Document Upload</p>
        <div className="flex gap-[28px]">
          <DocumentDetails
            label="Proof of Payment"
            type={
              payoutPayload.proofOfPaymentDocumentId ? 'success' : 'pending'
            }
          />
        </div>
      </div>
    </div>
  );
};
export default ReviewPayout;
